import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { UntypedFormGroup, FormGroup } from '@angular/forms';
import { FormTemplateFields } from '../form-template/form-template.component';
import moment from 'moment-timezone';
import { UiAuthService } from '@fullyops/legacy/ui/ui-crm/ui-auth.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';
import { addDateRangeValidation } from '@fullyops/shared/date-range-validation';
@Component({
  selector: 'crm-form-date',
  templateUrl: './form-date.component.html',
  styleUrls: ['./form-date.component.scss'],
  standalone: false,
})
export class FormDateComponent implements OnInit, OnDestroy {
  constructor(protected uiAuthService: UiAuthService) {}

  @Input() dateOnly = false;
  @Input() formGroup: UntypedFormGroup;
  @Input() field: FormTemplateFields<FormGroup<any>>;
  @Output() selectionChange = new EventEmitter();

  currentHour = null;
  currentMinutes = null;

  private sub = new Subscription();

  ngOnInit() {
    this.addCustomValidations();
  }

  parseHour(data: moment.Moment | Date | string): string {
    let momentData: moment.Moment;

    // Check the input type and convert to moment.Moment
    if (moment.isMoment(data)) {
      momentData = data;
    } else if (data instanceof Date) {
      momentData = moment(data);
    } else if (typeof data === 'string') {
      momentData = moment(data);
    } else {
      throw new Error(
        'Unsupported input format. Use moment.Moment, Date, or string.',
      );
    }

    // Format the time in the desired format (hh:mm)
    const formattedTime: string = momentData.format('HH:mm');
    return formattedTime;
  }

  onDateChange(event: MatDatepickerInputEvent<Date>) {
    this.onSelectChange(event);
  }

  onSelectChange(event: any) {
    this.selectionChange.emit(event);
  }

  getLabelName() {
    if (!this.field.label) {
      return 'forms:chooseTime';
    }
    if (this.field.label == 'endDate') {
      return 'forms:endingHour';
    }

    if (this.field.label == 'startDate') {
      return 'forms:startingHour';
    }

    return 'forms:chooseTime';
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  addCustomValidations() {
    const initialDateField = this.field.fullDate?.canNotBeBeforeThan;
    if (initialDateField != null) {
      this.sub.add(
        addDateRangeValidation(
          this.formGroup.controls[initialDateField],
          this.formGroup.controls[this.field.name],
        ),
      );
    }
  }
}
